import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Credentials, ImpersonateEmployee, ImpersonateEmployeeCredentials, Token } from '@core/models';
import { ImpersonateService } from '@core/services/impersonate.service';
import { position, onDragEnded } from '@shared/helpers/dialog-drag-constraints';
import { indicate, keepDialogOpen } from '@shared/helpers';
import { Observable, Subject } from 'rxjs';
import { ApplicationInsightsService, LayoutService } from '@core/services';

@Component({
    selector: 'app-impersonate',
    templateUrl: './impersonate.component.html',
    styleUrls: ['./impersonate.component.scss'],
    providers: [ImpersonateService],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ImpersonateComponent implements OnInit {
  static readonly componentName = 'ImpersonateComponent';
  
  public position = position;
  public onDragEnded = onDragEnded;

  form: UntypedFormGroup;
  impersonate$: Observable<ImpersonateEmployee>;
  isSearching$ = new Subject<boolean>();
  isSubmitting$ = new Subject<boolean>();
  public isMobile$: Observable<boolean>;
  sysText$: Observable<any>;

  get searchString(): string {
    return this.form.get('searchString').value;
  }

  get eeId(): number {
    return this.form.get('eeId').value;
  }

  constructor(
    private impersonationService: ImpersonateService,
    private fb: UntypedFormBuilder,
    private dialogRef: MatDialogRef<ImpersonateComponent>,
    private appInsightsService: ApplicationInsightsService,
    @Inject(MAT_DIALOG_DATA) public data: 
    { 
      sysText: any;
      creds: Credentials;
      token: Token;
    },
    private layoutService: LayoutService
  ) {
    this.form = this.fb.group({
      searchString: [''],
      eeId: [null]
    });
  }

  ngOnInit() {
    this.isMobile$ = this.layoutService.isMobile$();
    this.impersonate$ = this.impersonationService.impersonate$;
  }

  login(): void {
    const creds: ImpersonateEmployeeCredentials = {
      ...this.data.creds,
      // mat-selection-list provides an array, even though
      // multiple is set to false
      // get the eeId in the 0th position
      employeeId: this.eeId[0]
    };

    this.impersonationService
      .impersonateEmployee(creds, this.data.token)
      .pipe(
        indicate(this.isSubmitting$),
        keepDialogOpen(this.dialogRef)
      )
      .subscribe((res) => {
        this.dialogRef.close(res);
        // update application insights logging with the user_id
        res.user_id = this.eeId[0].toString();
        this.appInsightsService.setAuthenticatedUserContext(res.user_id, res.account_id);
      });
  }

  onSearch(): void {
    if (this.searchString) {
      let encodedString = encodeURI(this.searchString)
      this.impersonationService.searchForEmployees(encodedString, this.data.token).pipe(indicate(this.isSearching$)).subscribe();
    }
  }
}
